const state = {
  productModels: [],
  areProductModelsLoading: false,
  selectedProductModelEncodedBusinessName: null,
  searchProductModels: [],
  selectedSearchProductModel: {},
  productModelsAutoBom: {
    loading: true,
    counts: { activeCount: 0, inactiveCount: 0, completedCount: 0 },
    lastUpdate: ''
  }
}

export default state
